import { render, staticRenderFns } from "./DdQwLoadTip.vue?vue&type=template&id=79063c6a&scoped=true"
import script from "./DdQwLoadTip.vue?vue&type=script&lang=js"
export * from "./DdQwLoadTip.vue?vue&type=script&lang=js"
import style0 from "./DdQwLoadTip.vue?vue&type=style&index=0&id=79063c6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79063c6a",
  null
  
)

export default component.exports